import React, { useMemo } from 'react';
import useStyles from './CarrierStatus.styles';
import { endpoints } from '../../utils/endpoints';
import { useTranslation } from 'react-i18next';

import { IEditForm } from '../../types/interfaces/IEditForm';
import { Typography, Box, CircularProgress } from '@material-ui/core';
import tPaths from '../../utils/tPaths';
import { NSCarrierStatus } from '../../types/interfaces/NSCarrierStatus';
import useApi from '../../utils/useApi';
import InputFields from '../../components/ItemContent/InputFields/InputFields';

const CarrierStatus = () => {
  const styles = useStyles();
  const { t } = useTranslation();

  const { data } = useApi<NSCarrierStatus.IData>(endpoints.carrierStatus);

  const fields: IEditForm[][] = useMemo(() => {
    return [
      [
        {
          fieldName: 'status',
          type: 'read',
          initialValue: data?.available,
          label: 'Carrier API status',
          valueDisplayHandler: (value: boolean) => (
            <Typography
              variant="subtitle2"
              className={data?.available ? styles.available : styles.unavailable}
            >
              {/* evil laugh */}
              {data ? data.available ? 'Available' : 'Unavailable' : <CircularProgress size={16} />}
            </Typography>
          ),
        },
      ],
    ];
  }, [data, styles.available, styles.unavailable]);

  return (
    <Box margin={2}>
      <Typography variant="h4">{t(tPaths.itemContent.carrierApiStatus)}</Typography>
      <Box className={styles.container}>
        <InputFields data={fields} />
      </Box>
    </Box>
  );
};

export default CarrierStatus;
